import React from 'react'

import styles from 'components/pages/support/help/helpStyles'
import { HelpComponentProps } from 'types/Help'
import { useFormatMessage } from 'lib/localization'
import { isMyFeatureOn } from 'lib/splitio'
import { FEATURES } from 'lib/splitioFeatures'

const BASE_I18N_KEY = 'ess.help_outbound_anti_virus'

function OutboundAntiVirusI18n({ classes, productName }: { classes: ReturnType<typeof styles>; productName?: string }) {
  const formatMessage = useFormatMessage(BASE_I18N_KEY)
  return (
    <div className={classes.content} data-testid="content">
      {formatMessage('title')}
      {formatMessage('description', { productName })}
    </div>
  )
}

function OutboundAntiVirus(props: HelpComponentProps) {
  const classes = styles()
  let isSmartlingEnabled = false
  try {
    isSmartlingEnabled = isMyFeatureOn(FEATURES.EGD_React_Smartling_Translations)
  } catch {
    // Default to OFF when called outside Redux context (e.g., renderToString for search)
  }

  // Flag ON: Use translated content
  if (isSmartlingEnabled) {
    return <OutboundAntiVirusI18n classes={classes} productName={props.productName} />
  }

  // Flag OFF: Original hardcoded English content
  return (
    <div className={classes.content} data-testid="content">
      <h3>Scan Email for Viruses</h3>
      With virus scanning enabled, all outbound messages processed by {props.productName} are checked for viruses. Note:
      Detected viruses will not be quarantined or delivered to the intended recipient - even if the message has been
      allowed by a Block/Exempt filter. It is strongly recommended to set{' '}
      <b>Enable Virus Scanning of Outgoing Emails</b> to <i>Yes</i>.
    </div>
  )
}

export default OutboundAntiVirus
